"use client";

import { LocalizedTimeText } from "@/components/ui/localized-time-text";
import { CareFormStatusBadge } from "@/care-forms/components/care-forms/status-badge";
import {
	Box,
	Card,
	Container,
	Flex,
	Group,
	Loader,
	Space,
	Stack,
	Text,
	Title,
} from "@mantine/core";
import { Link } from "react-router";

import { CaregiverAppSettingsButton } from "@/caregiver-app/components/CaregiverAppSettingsButton";
import { useListMyCareSheets } from "@/caregiver-app/components/hooks";
import { ROUTES } from "@/setup/frontend/routes";
export default function CareSheetsPage() {
	const { data: careSheets, isLoading, error } = useListMyCareSheets();

	if (isLoading) {
		return (
			<Flex direction="column" h="100vh">
				<Box style={{ borderBottom: "1px solid var(--mantine-color-gray-3)" }}>
					<Group h={64} px="md" justify="space-between">
						<Title order={3} style={{ flex: 1, textAlign: "center" }}>
							Care Sheets
						</Title>
						<Box w={48} />
					</Group>
				</Box>
				<Flex align="center" justify="center" style={{ flex: 1 }}>
					<Loader size="lg" color="blue" />
				</Flex>
			</Flex>
		);
	}

	if (error) {
		return (
			<Flex direction="column" w="100%">
				<Box style={{ borderBottom: "1px solid var(--mantine-color-gray-3)" }}>
					<Group h={64} px="md" justify="space-between">
						<Title order={3} style={{ flex: 1, textAlign: "center" }}>
							Care Sheets
						</Title>
						<Box w={48} />
					</Group>
				</Box>
				<Container p="md">
					<Card withBorder>
						<Stack align="center" gap="md" p="md">
							<Text c="red" size="md">
								Error loading care sheets
							</Text>
							<Text c="red" size="sm">
								{error.message}
							</Text>
						</Stack>
					</Card>
				</Container>
			</Flex>
		);
	}

	return (
		<Flex direction="column" style={{ overflow: "hidden" }} flex={1}>
			<Box style={{ borderBottom: "1px solid var(--mantine-color-gray-3)" }}>
				<Group h={64} px="md" justify="space-between">
					<CaregiverAppSettingsButton />
					<Title order={3} style={{ flex: 1, textAlign: "center" }}>
						Care Sheets
					</Title>
					<Space />
				</Group>
			</Box>

			<Box style={{ flex: 1, overflowY: "auto" }}>
				<Container p="md">
					<Stack gap="md">
						{careSheets?.map((careSheet) => (
							<Card
								key={careSheet.id}
								style={{ cursor: "pointer" }}
								component={Link}
								to={ROUTES.CAREGIVER_APP.CARE_SHEETS.REVIEW(careSheet.id)}
								withBorder
							>
								<Group justify="space-between" align="flex-start">
									<Stack gap="xs">
										<Title order={4}>
											{careSheet.client.firstName} {careSheet.client.lastName}
										</Title>
										<Group gap="sm">
											<Text size="sm" c="dimmed">
												<LocalizedTimeText
													value={careSheet.startDate}
													format="MM/DD/YY"
												/>{" "}
												-{" "}
												<LocalizedTimeText
													value={careSheet.endDate}
													format="MM/DD/YY"
												/>
											</Text>
											<Text size="sm" c="dimmed">
												{careSheet.payerSource || ""}
											</Text>
											<Text size="sm" c="dimmed">{`#${careSheet.id}`}</Text>
										</Group>
									</Stack>
									<CareFormStatusBadge status={careSheet.status} />
								</Group>
							</Card>
						))}

						{careSheets?.length === 0 && (
							<Card>
								<Stack align="center" p="md">
									<Text c="dimmed">No care sheets found</Text>
								</Stack>
							</Card>
						)}
					</Stack>
				</Container>
			</Box>
		</Flex>
	);
}
